import { useTranslation } from '@shared/core';
import { Flex, TextV2 } from '@withjoy/joykit';
import { Info } from '@withjoy/joykit/icons';
import React from 'react';

export const OrderCanceledNotice = () => {
  const { t } = useTranslation('stationery');
  const t2 = t('dashboard', 'ordersList', 'digitalOrder');

  return (
    <Flex
      padding={6}
      border="1px solid #FFD8BB"
      borderRadius={3}
      gap={6}
    >
      <Info
        flex="none"
        color="#E0946D"
        size={32}
      />
      <Flex
        flexDirection="column"
        gap={3}
      >
        <TextV2 color="mono12">{t2.orderCanceled()}</TextV2>
      </Flex>
    </Flex>
  );
};
